
import DefaultLayout from "../../../layouts/DefaultLayout";
import React, {useContext, useEffect, useState} from "react";
import {useAuth} from "../../../providers/authProvider";
import BoxLayout from "../../../layouts/BoxLayout";
import DefaultButton from "../../buttons/DefaultButton";
import {ApiContext} from "../../contexts/ApiContext";
import H1Header from "../../headers/h1";
import H2Header from "../../headers/h2";
import NewPresentCategoryModal from "../../modals/NewPresentCategoryModal";
import EditPresentCategoryModal from "../../modals/EditPresentCategoryModal";
import {SmallTable} from "../../tables/SmallTable";
import NewPresentModal from "../../modals/NewPresentModal";
import EditPresentModal from "../../modals/EditPresentModal";
import EditButton from "../../buttons/EditButton";
import DeleteButton from "../../buttons/DeleteButton";
import ConfirmButton from "../../common/ConfirmButton";


function AdminPresentsPage() {

    const {Url } = useContext(ApiContext)
    const [presentCategories, setPresentCategories] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [openPresentCategoryModal, setOpenPresentCategoryModal] = useState(false);
    const [openEditPresentCategoryModal, setOpenEditPresentCategoryModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<any>(null);
    const [openPresentModal, setOpenPresentModal] = useState(false);
    const [openEditPresentModal, setOpenEditPresentModal] = useState(false);
    const [dataAvalible, setdataAvalible] = useState(false)
    const [rowDataPresent, setRowDataPresent] = useState<any>(null)
    const [authorized, setAuthorized] = useState(false)
    const [refreshTrigger, setRefreshTrigger] = useState(0)
    const { token } = useAuth();

    function handleRowDataPresent (rowData: any){
        setRowDataPresent(rowData)
        if (rowData){
            setOpenEditPresentModal(true)
        }
    }

    const handleDeletePresent = (id: number) => {
        fetch(Url + 'admin/presents/' + id, {
            method: 'DELETE',
            headers: {
                'Authorization': "Bearer " + token,
            },
        })
            .then((res) => res.json())
            .then(() => {
                setRefreshTrigger(prev => prev + 1);
            });
    }

    const handleDeletePresentCategory = (id: number) => {
        fetch(Url + 'admin/present-categories/' + id, {
            method: 'DELETE',
            headers: {
                'Authorization': "Bearer " + token,
            },
        })
            .then((res) => res.json())
            .then(() => {
                setRefreshTrigger(prev => prev + 1);
            });
    }

    useEffect(() => {
        if (token) {
            setLoading(true)
            fetch(Url + 'admin/present-categories', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) =>   {
                    if (res.status !== 200){
                        console.log("Data cannot be fetched")
                        setdataAvalible(false)
                        if (res.status === 401){
                            setAuthorized(false)
                        }else{
                            setAuthorized(true)
                        }
                    }else{
                        setAuthorized(true)
                        setdataAvalible(true)
                    } return res.json()
                })
                .then((data) => setPresentCategories(data))
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [token, Url, openPresentCategoryModal, openPresentModal, openEditPresentModal, openEditPresentCategoryModal, refreshTrigger]);


    const getColumnsPresents = () => [
        {
            Header: "ID",
            accessor: "ID",
        },
        {
            Header: "Naam",
            accessor: "Name",
        },
        {
            Header: "Index",
            accessor: "SortingIndex",
        },
        {
            Header: "Acties",
            Cell: ({ row }: { row: { original: any } }) => (
                <div className="flex gap-2">
                    <EditButton
                        onClick={() => handleRowDataPresent(row.original)}
                    />
                     <DeleteButton
                        confirmText={`Weet je zeker dat je het cadeau "${row.original.Name}" wilt verwijderen?`}
                        onConfirm={() => handleDeletePresent(row.original.ID)}
                    />
                </div>
            )
        }
    ];

    let table
    if (dataAvalible){
        table = (presentCategories.map(presentCategory =>
            <div key={presentCategory.ID} className="mb-8">
                <div className="flex items-center gap-2 mb-2">
                    <H2Header headerText={presentCategory.ID + ". " + presentCategory.Name + " - " + presentCategory.SalesPrice.toFixed(2) + " euro"}/>
                    <EditButton
                        onClick={() => {
                            setSelectedCategory(presentCategory);
                            setOpenEditPresentCategoryModal(true);
                        }}
                    />
                    <DeleteButton
                        confirmText={`Weet je zeker dat je de categorie "${presentCategory.Name}" wilt verwijderen?`}
                        onConfirm={() => handleDeletePresentCategory(presentCategory.ID)}
                    />
                </div>
                <SmallTable getColumns={getColumnsPresents()} onRowClick={() => {}} tableData={presentCategory.Presents}/>
            </div>
        ))
    }else{
        table = <div>Data niet beschikbaar of je hebt geen rechten om deze informatie te bekijken.</div>
    }

    return (
        <DefaultLayout>
            <div className="mb-4">
                <NewPresentCategoryModal openModal={openPresentCategoryModal} setOpenModal={() => setOpenPresentCategoryModal(false)}  />
                <EditPresentCategoryModal openModal={openEditPresentCategoryModal} setOpenModal={setOpenEditPresentCategoryModal} categoryInfo={selectedCategory}/>
                <NewPresentModal openModal={openPresentModal} setOpenModal={() => setOpenPresentModal(false)}  />
                <EditPresentModal openModal={openEditPresentModal} setOpenModal={() => setOpenEditPresentModal(false)} rowData={rowDataPresent}/>
            </div>

            {loading ? (
                <BoxLayout><div>Loading...</div></BoxLayout>

            ) : (
                <BoxLayout>

                    {authorized && <H1Header headerText="Cadeau overzicht" />}
                    <div className="flex gap-4 mt-4 mb-4">
                        {authorized &&  <DefaultButton content="Nieuwe categorie"  onClick={() => setOpenPresentCategoryModal(true)} disabled={false}></DefaultButton> }
                        {authorized &&  <DefaultButton content="Nieuw cadeau"  onClick={() => setOpenPresentModal(true)} disabled={false}></DefaultButton>}
                    </div>

                    <div className="flex flex-col overflow-auto py-4 sm:py-0">
                        {table}
                    </div>
                </BoxLayout>
            )}
        </DefaultLayout>
    )
}
export default AdminPresentsPage
